// Pure beat-grid maths for arrangement playback (no audio, unit-tested).

/** Total beats an arrangement spans (end of the last-ending event). */
export function arrangementSpanBeats(
  events: { startBeat: number; durationBeats: number }[],
): number {
  return events.reduce((max, e) => Math.max(max, e.startBeat + Math.max(1, e.durationBeats)), 0);
}
